import React from "react";
import PropTypes from "prop-types";
import { FaCheck } from "react-icons/fa";

import { customerSurveyConstants } from "../../../../constants";
import QuestionHeadingLogo from "./questionHeadingLogo";

/**
 * Shared survey status / summary UI (submitted, expired, already submitted, etc.).
 */
const SurveyStatusMessage = ({
  title,
  showHeadingLogo = false,
  brandDetail,
  showCheckIcon = false,
  containerClassName = "d-flex flex-column align-items-center question-container custom-height",
  titleClassName = "fw-bold text-center",
  children,
}) => {
  const content = (
    <div className={containerClassName}>
      <div className="my-auto text-center px-1">
        {showCheckIcon && (
          <div className="d-flex align-items-center justify-content-center p-2">
            <span className="p-2 rounded-pill green-background-color">
              <FaCheck
                color="white"
                size={customerSurveyConstants.CHECK_ICON_SIZE}
              />
            </span>
          </div>
        )}
        <h2 className={titleClassName}>{title}</h2>
        {children}
      </div>
    </div>
  );

  if (showHeadingLogo) {
    return (
      <>
        <QuestionHeadingLogo brandDetail={brandDetail} />
        {content}
      </>
    );
  }

  return content;
};

SurveyStatusMessage.propTypes = {
  title: PropTypes.string.isRequired,
  showHeadingLogo: PropTypes.bool,
  brandDetail: PropTypes.object,
  showCheckIcon: PropTypes.bool,
  containerClassName: PropTypes.string,
  titleClassName: PropTypes.string,
  children: PropTypes.node,
};

export default SurveyStatusMessage;
